import { render, staticRenderFns } from "./TableColumnsEditDialog.vue?vue&type=template&id=495929bf&scoped=true"
import script from "./TableColumnsEditDialog.vue?vue&type=script&lang=js"
export * from "./TableColumnsEditDialog.vue?vue&type=script&lang=js"
import style0 from "./TableColumnsEditDialog.vue?vue&type=style&index=0&id=495929bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495929bf",
  null
  
)

export default component.exports